import { SignOutOpts } from "@aws-amplify/auth/lib-esm/types";
import { PostHog } from "posthog-js";
import {
  GetUserIfLoggedIn,
  IdentityState,
  getActiveOrganisation,
  signOut,
  switchedOrganisationCookieName,
} from "contexts/identity-context";

export function getName(identity: IdentityState): string {
  if (!identity) {
    return "";
  }
  const organisation = getActiveOrganisation(identity);

  if (organisation) {
    return organisation.name;
  }
  return getFullName(identity);
}

export function getFullName(identity: IdentityState): string {
  const user = GetUserIfLoggedIn(identity);
  if (!user) {
    return "";
  }

  return `${user.firstName} ${user.lastName}`;
}

export async function logOut(
  setUserState: React.Dispatch<React.SetStateAction<IdentityState>>,
  removeCookie: (
    name: typeof switchedOrganisationCookieName,
    options?: any
  ) => void,
  shutdown: () => void,
  posthog: PostHog,
  opts?: SignOutOpts
) {
  await signOut(removeCookie, opts);
  setUserState(false);
  shutdown();
  posthog.capture("user_signed_out");
}
